export default "__VITE_ASSET__8d56daf9__"